import { AfterViewInit, Component, OnInit, ViewChild, inject, output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { LoginModel } from '../../core/models/auth/login.model';
import { FormControlNameRecord } from '../../shared/data-types/form-types';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false,
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('password') public textbox: TextBoxComponent;
  readonly formSubmitted$ = output<LoginModel>();
  readonly showRegister$ = output<void>();
  public loginForm: FormGroup;
  public errorMsg = null;
  public requestSent = false;

  public formControlNames: FormControlNameRecord = {
    UserName: 'username',
    Password: 'password',
    RememberMe: 'rememberMe',
  };

  // DI
  private readonly formBuilder = inject(FormBuilder);

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.textbox.input.nativeElement.type = 'password';
  }

  public login(): void {
    this.loginForm.markAllAsTouched();

    if (!this.loginForm.valid) {
      return;
    }

    const loginUser = new LoginModel();
    loginUser.email = this.loginForm.controls[this.formControlNames.UserName].value;
    loginUser.password = this.loginForm.controls[this.formControlNames.Password].value;
    this.formSubmitted$.emit(loginUser);
  }

  public showRegister(): void {
    this.showRegister$.emit();
  }

  private initForm(): void {
    this.loginForm = this.formBuilder.group({
      [this.formControlNames.UserName]: ['', Validators.required],
      [this.formControlNames.Password]: ['', [Validators.required]],
      [this.formControlNames.RememberMe]: '',
    });
  }
}
